// import React, { useEffect } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import { motion } from 'framer-motion';
// import { useSelector, useDispatch } from 'react-redux';
// import BasicInformation from './BasicInformation';
// import BusinessLocationForm from './BusinessLocationForm';
// import DiversityVerificationForm from './DiversityVerificationForm';
// import LoginHeader from '../Login/LoginHeader';
// import ServicesCapabilitiesForm from './ServicesCapabilitiesForm';
// import RegistrationComplianceForm from './RegistrationComplianceForm';
// import TestimonialsReferencesForm from './TestimonialsReferencesForm';
// import StatusVerificationForm from './StatusVerificationForm';
// import MembershipCertificationsForm from './MembershipCertificationsForm';
// import PersonalInfoForm from '../../Registration/PersonalInfoForm';
// import ReviewPage from './ReviewPage';
// import RegistrationConfirmation from './RegistrationConfirmation';

// const steps = [
//   {
//     id: 1,
//     name: "Personal Details",
//     slug: "personal-details",
//     component: PersonalInfoForm,
//   },
//   {
//     id: 2,
//     name: 'Supplier Info',
//     slug: 'basic-information',
//     component: BasicInformation,
//   },
//   {
//     id: 3,
//     name: 'Business Location',
//     slug: 'business-location',
//     component: BusinessLocationForm,
//   },
//   {
//     id: 4,
//     name: 'Registration and compliance',
//     slug: 'registration-compliance',
//     component: RegistrationComplianceForm,
//   },
//   {
//     id: 5,
//     name: 'Services and capabilities',
//     slug: 'services-capabilities',
//     component: ServicesCapabilitiesForm,
//   },
//   {
//     id: 6,
//     name: 'Diversity Data and verification',
//     slug: 'diversity-verification',
//     component: DiversityVerificationForm,
//   },
//   {
//     id: 7,
//     name: 'Testimonial and references',
//     slug: 'testimonials-references',
//     component: TestimonialsReferencesForm,
//   },
//   {
//     id: 8,
//     name: 'Membership Associations & Certifications',
//     slug: 'membership-certifications',
//     component: MembershipCertificationsForm,
//   },
//   {
//     id: 9,
//     name: "Review",
//     slug: "review",
//     component: ReviewPage,
//   },
//   {
//     id: 10,
//     name: "Registration Confirmation",
//     slug: "registration-confirmation",
//     component: RegistrationConfirmation,
//   },
// ];

// const MultiStepForm = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { isAuthenticated } = useSelector((state) => state.auth);
//   const { stepSlug } = useParams();
//   const currentStep = steps.findIndex((step) => step.slug === stepSlug);


//   useEffect(() => {
//     if (currentStep === -1) {
//       navigate(`/supplier-profile-registration/${steps[0].slug}`, { replace: true });
//     }
//   }, [currentStep, navigate]);

//   if (currentStep === -1) return null;

//   const handleNext = () => {
//     if (!isAuthenticated) {
//       alert('Please log in to continue.');
//       navigate('/login')
//       return;
//     }
//     if (currentStep < steps.length - 1) {
//       navigate(`/supplier-profile-registration/${steps[currentStep + 1].slug}`);
//     }
//   };

//   const handleSkip = () => {
//     if (currentStep < steps.length - 1) {
//       navigate(`/supplier-profile-registration/${steps[currentStep + 1].slug}`);
//     }
//   };

//   const CurrentComponent = steps[currentStep].component;

//   return (
//     <div className="flex min-h-screen bg-white">
//       <LoginHeader isAuthenticated={isAuthenticated} registrationPage={true} />
//       <div className="flex flex-col fixed left-2 sm:left-4 md:left-6 lg:left-8 top-[50%] transform -translate-y-1/2">
//         {steps.map((step, index) => {
//           const isCompleted = index < currentStep;
//           const isActive = index === currentStep;
//           const iconColor = isCompleted || isActive ? "#08F" : "#A7A7A7";
//           const textColor =
//             isCompleted || isActive ? "text-[#08F]" : "text-[#A7A7A7]";

//           return (
//             <div key={step.id} className="flex items-center p-2">
//               <div className="flex items-center relative">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="13"
//                   height="13"
//                   viewBox="0 0 10 10"
//                   fill="none"
//                   style={{ zIndex: 100 }}
//                   className="align-middle"
//                   onClick={() => {
//                     if (isCompleted) {
//                       navigate(`/supplier-profile-registration/${step.slug}`);
//                     }
//                   }}
//                 >
//                   <path
//                     d="M5 9.5C7.48528 9.5 9.5 7.48528 9.5 5C9.5 2.51472 7.48528 0.5 5 0.5C2.51472 0.5 0.5 2.51472 0.5 5C0.5 7.48528 2.51472 9.5 5 9.5Z"
//                     fill="white"
//                     stroke={iconColor}
//                     strokeWidth="1"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                   <path
//                     d="M6.5 3.99951L4.5 5.99951L3.5 4.99951"
//                     stroke={iconColor}
//                     strokeWidth="1.5"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                 </svg>

//                 {index !== steps.length - 1 && (
//                   <div
//                     className={`absolute top-0 bottom-0 left-[calc(50%)] w-px h-10 ${
//                       index < currentStep ? "bg-[#08F]" : "bg-[#A7A7A7]"
//                     }`}
//                   />
//                 )}
//               </div>

//               <div
//                 className="cursor-pointer items-center ml-2 hidden xl:block"
//                 onClick={() => {
//                   if (isCompleted) {
//                     navigate(`/supplier-profile-registration/${step.slug}`);
//                   }
//                 }}
//               >
//                 <p
//                   className={`text-sm font-semibold ${textColor} align-middle`}
//                 >
//                   {step.name}
//                 </p>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//       <div className="flex-1 flex justify-center items-center pt-[80px] md:pt-[100px]">
//         <motion.div
//           key={currentStep}
//           initial={{ opacity: 0, x: 20 }}
//           animate={{ opacity: 1, x: 0 }}
//           exit={{ opacity: 0, x: -20 }}
//           transition={{ duration: 0.5 }}
//           className="w-full max-w-[800px] p-6"
//         >
//           <CurrentComponent onNext={handleNext} onSkip={handleSkip} onEditStep={(slug) => navigate(`/supplier-profile-registration/${slug}`)}  />
//         </motion.div>
//       </div>
//     </div>
//   );
// };

// export default MultiStepForm;


import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { motion, AnimatePresence } from "framer-motion";
import { useSelector, useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import { setParamsExist } from '../../store/ParamSlice';
import BasicInformation from './BasicInformation';
import BusinessLocationForm from './BusinessLocationForm';
import DiversityVerificationForm from './DiversityVerificationForm';
import LoginHeader from '../Login/LoginHeader';
import ServicesCapabilitiesForm from './ServicesCapabilitiesForm';
import RegistrationComplianceForm from './RegistrationComplianceForm';
import TestimonialsReferencesForm from './TestimonialsReferencesForm';
import StatusVerificationForm from './StatusVerificationForm';
import MembershipCertificationsForm from './MembershipCertificationsForm';
import PersonalInfoForm from '../../Registration/PersonalInfoForm';
import ReviewPage from './ReviewPage';
import RegistrationConfirmation from './RegistrationConfirmation';

const steps = [
  { id: 1, name: "Personal Details", slug: "personal-details", component: PersonalInfoForm },
  { id: 2, name: 'Supplier Info', slug: 'basic-information', component: BasicInformation },
  { id: 3, name: 'Business Location', slug: 'business-location', component: BusinessLocationForm },
  { id: 4, name: 'Registration and compliance', slug: 'registration-compliance', component: RegistrationComplianceForm },
  { id: 5, name: 'Services and capabilities', slug: 'services-capabilities', component: ServicesCapabilitiesForm },
  { id: 6, name: 'Diversity Data and verification', slug: 'diversity-verification', component: DiversityVerificationForm },
  { id: 7, name: 'Testimonial and references', slug: 'testimonials-references', component: TestimonialsReferencesForm },
  { id: 8, name: 'Membership Associations & Certifications', slug: 'membership-certifications', component: MembershipCertificationsForm },
  { id: 9, name: "Review", slug: "review", component: ReviewPage },
  { id: 10, name: "Registration Confirmation", slug: "registration-confirmation", component: RegistrationConfirmation },
];

const MultiStepForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);
  const { stepSlug } = useParams();
  const [searchParams] = useSearchParams();
  const buyerId = searchParams.get("buyerId");
  const currentStep = steps.findIndex((step) => step.slug === stepSlug);
  const [showRedirectModal, setShowRedirectModal] = useState(false);
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    if (buyerId) {
      dispatch(
        setParamsExist({
          exists: true,
          buyerId,
        })
      );

      if (!isAuthenticated) {
        setShowRedirectModal(true);
        setCountdown(5);
      }
    }
  }, [buyerId, isAuthenticated, dispatch]);

  useEffect(() => {
    let timer;
    if (showRedirectModal && countdown > 0) {
      timer = setTimeout(() => setCountdown((prev) => prev - 1), 1000);
    } else if (showRedirectModal && countdown === 0) {
      navigate(`/login?buyerId=${buyerId}`, { replace: true });
    }
    return () => clearTimeout(timer);
  }, [showRedirectModal, countdown, buyerId, navigate]);

  

  useEffect(() => {
    if (currentStep === -1) {
      navigate(`/supplier-profile-registration/${steps[0].slug}`, { replace: true });
    }
  }, [currentStep, navigate]);

  if (currentStep === -1) return null;

  const handleNext = () => {
    if (!isAuthenticated) {
      alert('Please log in to continue.');
      const buyerIdFromCookie = Cookies.get("buyerId");
      const loginUrl = buyerIdFromCookie
        ? `/login?buyerId=${buyerIdFromCookie}`
        : "/login";
      navigate(loginUrl);
      return;
    }
    if (currentStep < steps.length - 1) {
      navigate(`/supplier-profile-registration/${steps[currentStep + 1].slug}`);
    }
  };

  const handleSkip = () => {
    if (currentStep < steps.length - 1) {
      navigate(`/supplier-profile-registration/${steps[currentStep + 1].slug}`);
    }
  };

  const CurrentComponent = steps[currentStep].component;

  return (
    <div className="flex min-h-screen bg-white">
      <LoginHeader isAuthenticated={isAuthenticated} registrationPage={true} />
      {/* Sidebar Steps */}
      <div className="flex flex-col fixed left-2 sm:left-4 md:left-6 lg:left-8 top-[50%] transform -translate-y-1/2">
        {steps.map((step, index) => {
          const isCompleted = index < currentStep;
          const isActive = index === currentStep;
          const iconColor = isCompleted || isActive ? "#08F" : "#A7A7A7";
          const textColor = isCompleted || isActive ? "text-[#08F]" : "text-[#A7A7A7]";

          return (
            <div key={step.id} className="flex items-center p-2">
              <div className="flex items-center relative">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="13"
                  viewBox="0 0 10 10"
                  fill="none"
                  style={{ zIndex: 100 }}
                  className="align-middle"
                  onClick={() => {
                    if (isCompleted) {
                      navigate(`/supplier-profile-registration/${step.slug}`);
                    }
                  }}
                >
                  <path
                    d="M5 9.5C7.48528 9.5 9.5 7.48528 9.5 5C9.5 2.51472 7.48528 0.5 5 0.5C2.51472 0.5 0.5 2.51472 0.5 5C0.5 7.48528 2.51472 9.5 5 9.5Z"
                    fill="white"
                    stroke={iconColor}
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M6.5 3.99951L4.5 5.99951L3.5 4.99951"
                    stroke={iconColor}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                {index !== steps.length - 1 && (
                  <div
                    className={`absolute top-0 bottom-0 left-[calc(50%)] w-px h-10 ${
                      index < currentStep ? "bg-[#08F]" : "bg-[#A7A7A7]"
                    }`}
                  />
                )}
              </div>
              <div
                className="cursor-pointer items-center ml-2 hidden xl:block"
                onClick={() => {
                  if (isCompleted) {
                    navigate(`/supplier-profile-registration/${step.slug}`);
                  }
                }}
              >
                <p className={`text-sm font-semibold ${textColor} align-middle`}>
                  {step.name}
                </p>
              </div>
            </div>
          );
        })}
      </div>

      {/* Form container */}
      <div className="flex-1 flex justify-center items-center pt-[80px] md:pt-[100px]">
        <motion.div
          key={currentStep}
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -20 }}
          transition={{ duration: 0.5 }}
          className="w-full max-w-[800px] p-6"
        >
          <CurrentComponent
            onNext={handleNext}
            onSkip={handleSkip}
            onEditStep={(slug) =>
              navigate(`/supplier-profile-registration/${slug}`)
            }
          />
        </motion.div>
      </div>

       <AnimatePresence>
        {showRedirectModal && (
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[200]"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="bg-white rounded-2xl shadow-xl p-8 max-w-xl text-center"
            >
              <h2 className="text-xl font-semibold text-gray-800 mb-3">
                You’ll be redirected to login
              </h2>
              <p className="text-gray-600 mb-6">
                Please log in to continue your registration.
                <br />
                If you don’t have an account, sign up instead.
              </p>
              <p className="text-4xl font-bold text-[#08F] mb-2">{countdown}</p>
              <button
                onClick={() => {
                  setShowRedirectModal(false);
                  navigate(`/login?buyerId=${buyerId}`);
                }}
                className=" bg-[#EDFD76] rounded text-base text-black py-2 px-6 mt-4"
              >
                OK
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default MultiStepForm;
